import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import React from "react";
import PropTypes from "prop-types";
import { LuHouse } from "react-icons/lu";
export default function HeaderLogo({ navigate }) {
  useUiTranslation();
  return <button type="button" className="lina-brand" onClick={() => navigate("/")} aria-label={uiI18n.t("ui.lina_immo_home")}>
    <span className="lina-brand-mark"><LuHouse size={24} strokeWidth={1.8} /></span>
    <span><span className="lina-brand-name">LINA <strong>IMMO</strong></span><span className="lina-brand-tagline">{uiI18n.t("ui.real_estate_made_simple")}</span></span>
  </button>;
}
HeaderLogo.propTypes = { navigate: PropTypes.func.isRequired };
